import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { KpiAnalyticsScheduleModel } from '../../../services-api-v2/kpi-follow-up/models/kpi-analytics-schedule.model';
import {ProcessDetailScheduleService} from '../../../services-api-v2/kpi-follow-up/general/process-detail-schedule.service';

@Component({
    selector: 'app-kpi-process-analytics-schedule-chart',
    templateUrl: './kpi-process-analytics-schedule-chart.component.html',
    styleUrls: ['./kpi-process-analytics-schedule-chart.component.scss'],
    standalone: false
})
export class KpiProcessAnalyticsScheduleChartComponent implements OnInit, OnChanges, OnDestroy {

  @Input() endRange: number;
  @Input() startRange: number;
  @Input() queryService: ProcessDetailScheduleService;
  @Input() plannedEventsIds: string[];
  @Input() tClassBlocksIds: string[];
  @Input() processStartEnd: number[];

  public scheduleData: BehaviorSubject<KpiAnalyticsScheduleModel> = new BehaviorSubject<KpiAnalyticsScheduleModel>(null);
  public endRange$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public startRange$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public processStartEnd$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public plannedEventsIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
  public tClassBlocksIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);

  private unsubscriber = new ReplaySubject();

  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.endRange) {
      this.endRange$.next(changes.endRange.currentValue);
    }
    if (changes && changes.startRange) {
      this.startRange$.next(changes.startRange.currentValue);
    }
    if (changes && changes.plannedEventsIds) {
      this.plannedEventsIds$.next(changes.plannedEventsIds.currentValue);
    }
    if (changes && changes.tClassBlocksIds) {
      this.tClassBlocksIds$.next(changes.tClassBlocksIds.currentValue);
    }
    if (changes && changes.processStartEnd) {
      this.processStartEnd$.next(changes.processStartEnd.currentValue);
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  private getData(): void {
    if (this.queryService) {
      combineLatest([
        this.startRange$,
        this.endRange$,
        this.plannedEventsIds$,
        this.tClassBlocksIds$
      ]).pipe(
        takeUntil(this.unsubscriber),
        distinctUntilChanged((a: any, b: any) => JSON.stringify(a) === JSON.stringify(b)),
        tap(() => this.scheduleData.next(null)),
        filter(([startRange, endRange, plannedEventsIds, tClassBlocksIds]) =>
          !!startRange && !!endRange && !!plannedEventsIds && !!tClassBlocksIds
        ),
        switchMap(([startRange, endRange, plannedEventsIds, tClassBlocksIds]) => {
              return this.queryService.getProcessScheduleData(startRange, endRange, plannedEventsIds, tClassBlocksIds);
            }
        )
      ).subscribe((data: KpiAnalyticsScheduleModel) => {
        this.scheduleData.next(data);
      });
    }
  }

}
